import React from 'react';
import { inject, observer } from 'mobx-react';
import { Divider, Group, Paper, Stack } from '@mantine/core';
import { TableContextProvider } from '../../../global/hooks/useTable.tsx';
import { useSimulation } from '../../../global/hooks/useSimulation.tsx';
import DosageSimulationTable from '../Table/DosageSimulationTable.tsx';
import GraphSimulation from '../Graph/GraphSimulation.tsx';
import GraphResponse from '../Graph/GraphResponse.tsx';

const DosageModelingSimulation: React.FC = inject()(
    observer(() => {
        const { simulationCurveGraph, simulationId } = useSimulation();

        return (
            <Paper w="100%" radius="lg" shadow="sm" style={{ position: 'relative' }}>
                <Group>
                    <TableContextProvider>
                        <DosageSimulationTable />
                    </TableContextProvider>

                    <Divider hidden={!simulationCurveGraph && simulationId === -1} mt={'lg'} mb={'md'} />
                </Group>
                {simulationCurveGraph ? (
                    <Stack>
                        <GraphSimulation />
                        <Divider mt={'lg'} mb={'md'} />
                        <GraphResponse />
                    </Stack>
                ) : null}
            </Paper>
        );
    }),
);

export default DosageModelingSimulation;

